import { useState } from "react";

const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
export default function useUpdateUserPayment(token) {
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);
  const update = async (paymentId, updates) => {
    setLoading(true);
    const res = fetch(
      `${BASE_URL}subscription/admin/payments/by-user?paymentId=${paymentId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({ ...updates }),
      },
    ).then((res) => {
      if (res.status === 404) {
        setNotification({ type: "error", message: "Pagamento não encontrado" });
        throw new Error("Pagamento não encontrado");
      } else if (res.ok)
        setNotification({
          type: "success",
          message: "Pagamento atualizado com sucesso",
        });
      else if (!res.ok) {
        throw new Error("Erro ao atualizar pagamento");
      }
    });
    await res.finally(() => setLoading(false));
  };

  return { update, notification, loading };
}
